import React from 'react';

import { BaseIconProps } from '.';

export const HourGlassHalf = ({ fill }: BaseIconProps) => (
  <path
    transform="matrix(21.59784,0,0,21.59784,-17510.427,-12721.128)"
    d="m 844.829,601.501 h -18.153 a 18.323,18.323 0 0 1 -1.081,-6.25 h 20.314 c 0,2.227 -0.39,4.354 -1.08,6.25 z m -0.002,25.002 h -18.15 c 1.666,-4.57 5.088,-7.813 9.075,-7.813 3.987,0 7.409,3.242 9.075,7.813 z M 852.159,589 H 819.344 A 2.344,2.344 0 0 0 817,591.344 v 1.563 a 2.344,2.344 0 0 0 2.344,2.344 c 0,8.884 4.982,16.381 11.802,18.751 -6.82,2.37 -11.802,9.868 -11.802,18.752 A 2.344,2.344 0 0 0 817,635.098 v 1.563 a 2.344,2.344 0 0 0 2.344,2.344 h 32.815 a 2.344,2.344 0 0 0 2.344,-2.344 v -1.563 a 2.344,2.344 0 0 0 -2.344,-2.344 c 0,-8.884 -4.982,-16.382 -11.802,-18.752 6.82,-2.37 11.802,-9.867 11.802,-18.751 a 2.344,2.344 0 0 0 2.344,-2.344 v -1.563 A 2.344,2.344 0 0 0 852.16,589 Z"
    fill={fill}
  />
);
